import { environment } from 'src/environments/environment';
import { XFileUploader } from '../xFileUploader';

export class RegenerativeProtocolPractice {
  id: string = null;
  isRequired: boolean = false;
}
export class RegenerativeProtocolCreate {
  name: string = '';
  cropYear: number = null;
  numberYear: number = null;
  imgUrl: string = null;
  practice: RegenerativeProtocolPractice[] = [];
  companyId: number = null; // The company creating the protocol - we take the child'one when logged in as head of Supply Chain.
  companyIdAssignee: number[] = [];
  status: string = null;
  temporaryImage?: XFileUploader = null;
}
export class RegenerativeProtocolUpdate extends RegenerativeProtocolCreate {
  id: string = null;
}

export class RegenerativeProtocol extends RegenerativeProtocolUpdate {
  userCreated: number = null;
  companyIdCreated: number = null;
  dateCreated: Date = null;
  lastModify: Date = null;
}

export const ProtocolStatus = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
};

export const RegenerativeProtocolEditSteps = {
  BasicInfo: 'basic-information',
  SelectPractices: 'select-practices',
  SelectCompanies: 'select-companies',
  Recap: 'recap',
};

export enum RegenerativeProtocolNavigationButton {
  CANCEL = 'cancel',
  BACK = 'back',
  CONTINUE = 'continue',
  SAVE_DRAFT = 'save_draft',
  PUBLISH = 'publish',
  CLOSE = 'close',
}

export const RegenerativeProtocolDefaultImage = {
  imageURL: environment.publicAssetsUrl + 'checks/open-field.jpg',
};
